import React from "react";
import style from "./style.module.css";
import Eye from "../../images/eye-con.svg";
import { Insight, InsightAnatomy } from "../insight";

export interface InsightOverviewProps {
    insights: InsightAnatomy[];
}

export function InsightOverview(props: InsightOverviewProps) {


    return (
        <section className={style.insightOverview}>
            <section className={style.header}>
                <img
                    className={style.icon}
                    src={Eye}
                    alt="Lightbulb that looks like an eye looking to the right"
                />
                <h4 className={style.title}>what we learned</h4>
            </section>
            {
                props.insights.map((insight: InsightAnatomy, index: number) => {
                    return (
                        <Insight
                            key={index}
                            index={index}
                            insight={insight}
                        />
                    );
                })
            }
        </section>
    );
}